// 二次封装微信配置以及微信sdk的api调用
import wx from "weixin-js-sdk";
import { isIos } from "./tools";

const _log = console.log;

class Wx {
  static instance = null;
  static getInstance() {
    if (!Wx.instance) {
      Wx.instance = new Wx();
    }
    return Wx.instance;
  }

  constructor() {
    this.wx = wx;
    this.isConfig = false;
    this.configoptions = {
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: undefined, // 必填，公众号的唯一标识
      timestamp: undefined, // 必填，生成签名的时间戳
      nonceStr: undefined, // 必填，生成签名的随机串
      signature: undefined, // 必填，签名
      jsApiList: [
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "onMenuShareQQ",
        "onMenuShareWeibo",
        "onMenuShareQZone"
      ] // 必填，需要使用的JS接口列表
    };
  }

  isNeedConfig() {
    return !(isIos() && this.isConfig);
  }

  /**
   * debug 开启调试模式，调用的所有api的返回值会在客户端alert出来，如果要查看传入的参数，可以在PC端打开，参数信息会通过log打出，仅在PC端打印
   * appId 必填，公众号的唯一标识
   * timestamp 必填，生成签名的时间戳
   * nonceStr 必填，生成签名的随机串
   * signature 必填，签名
   * jsApiList 必填，需要使用的JS接口列表
   * */

  config(options) {
    return new Promise((resolve, reject) => {
      // ios系统一次会话只需要配置一次，因为ios只要首页面url
      // 判断是否需要配置
      if (!this.isNeedConfig()) {
        resolve();
      } else {
        this.wx.config(options);
        this.configoptions = {
          debug: options.debug || false,
          appId: options.appId || "",
          timestamp: options.timestamp || "",
          nonceStr: options.nonceStr || "",
          signature: options.signature || "",
          jsApiList: options.jsApiList || []
        };

        // wx.config配置成功
        this.wx.ready(() => {
          // ios首次配置，设置配置标识为已配置
          if (isIos()) {
            this.isConfig = true;
          }
          resolve();
        });

        // wx.config配置失败返回错误信息
        this.wx.error(err => {
          reject(err);
        });
      }
    });
  }

  //
  /**
   * 分享朋友圈，好友，QQ，微博
   * @param {Object} options
   * @param {String} options.title 标题
   * @param {String} options.desc 描述
   * @param {String} options.link 链接
   * @param {String} options.imgUrl 缩略图
   */
  share(options) {
    if (this.configoptions.debug) {
      _log(options);
    }
    this.wx.onMenuShareTimeline(options);
    this.wx.onMenuShareAppMessage(options);
    this.wx.onMenuShareQQ(options);
    this.wx.onMenuShareWeibo(options);
  }
}

export default Wx;
